import { QarepaEnumInformation } from '@qarepa/common';

export enum ProjectTaskStatusEnum {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
}

export type ProjectTaskStatusType =
  ProjectTaskStatusEnum.PENDING | ProjectTaskStatusEnum.COMPLETED;

export const ProjectTaskStatusArray = [
  ProjectTaskStatusEnum.PENDING,
  ProjectTaskStatusEnum.COMPLETED,
];

export const ProjectTaskStatusInfo: QarepaEnumInformation<ProjectTaskStatusEnum> =
  {
    [ProjectTaskStatusEnum.PENDING]: {
      name: $localize`Pendiente`,
    },
    [ProjectTaskStatusEnum.COMPLETED]: {
      name: $localize`Completado`,
    },
  };
